import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/customers', { params });
}

export const all = async (params) => {
    return await server().get('api/customers', { params: { all: true, ...params } });
}

export const show = async (id) => {
    return await server().get(`api/customers/${id}`);
}

export const create = async (customer) => {
    return await server().post('api/customers', customer);
}

export const update = async (id, customer) => {
    return await server().post(`api/customers/${id}`, customer);
}

export const remove = async (id) => {
    return await server().delete(`api/customers/${id}`);
}

export const portalAccess = async (id, payload) => {
    return await server().post(`api/customers/${id}/portal-access`, payload);
}

export default { paginate, all, show, create, update, remove, portalAccess };
